import * as React from "react";

function CheckIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 10 10" {...props}>
      <path d="M9.723 2.802l-5.4 5.184a.999.999 0 01-1.353 0L.275 5.399a.903.903 0 010-1.298.997.997 0 011.353 0l2.03 1.948 4.724-4.535a.999.999 0 011.353 0 .901.901 0 01-.012 1.288z" />
    </svg>
  );
}

const MemoCheckIcon = React.memo(CheckIcon);
export default MemoCheckIcon;
